import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "question-result-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_checkable_text_question = _resolveComponent("quiz-checkable-text-question");
  const _component_quiz_blanks_question = _resolveComponent("quiz-blanks-question");
  const _component_quiz_pairs_matching_question = _resolveComponent("quiz-pairs-matching-question");
  const _component_quiz_sorting_question = _resolveComponent("quiz-sorting-question");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAnswers, (questionResult, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.isCheckableQuestion(questionResult) ? (_openBlock(), _createBlock(_component_quiz_checkable_text_question, {
      key: 0,
      class: "exam-quiz-question",
      question: _ctx.getSourceQuestion(questionResult.questionId),
      "question-custom-label": _ctx.getQuestionLabel(questionResult.questionId, index + 1),
      selected: _ctx.getCheckableQuestionUserAnswers(questionResult),
      "right-answer": _ctx.getCheckableQuestionRightAnswers(questionResult.questionId),
      "display-overall-verdict-icon": true,
      "is-result-mode": true
    }, null, 8, ["question", "question-custom-label", "selected", "right-answer"])) : _ctx.isBlanksQuestion(questionResult) ? (_openBlock(), _createBlock(_component_quiz_blanks_question, {
      key: 1,
      class: "exam-quiz-question",
      question: _ctx.getSourceQuestion(questionResult.questionId),
      "question-custom-label": _ctx.getQuestionLabel(questionResult.questionId, index + 1),
      "user-blanks-answers": _ctx.getBlanksQuestionUserAnswers(questionResult),
      "display-overall-verdict-icon": true,
      "is-result-mode": true
    }, null, 8, ["question", "question-custom-label", "user-blanks-answers"])) : _ctx.isPairsMatchingQuestion(questionResult) ? (_openBlock(), _createBlock(_component_quiz_pairs_matching_question, {
      key: 2,
      class: "exam-quiz-question",
      question: _ctx.getSourceQuestion(questionResult.questionId),
      "question-custom-label": _ctx.getQuestionLabel(questionResult.questionId, index + 1),
      "user-pairs-matching": _ctx.getUserPairsMatching(questionResult),
      "display-overall-verdict-icon": true,
      "is-result-mode": true
    }, null, 8, ["question", "question-custom-label", "user-pairs-matching"])) : _ctx.isSortingQuestion(questionResult) ? (_openBlock(), _createBlock(_component_quiz_sorting_question, {
      key: 3,
      class: "exam-quiz-question",
      question: _ctx.getSourceQuestion(questionResult.questionId),
      "question-custom-label": _ctx.getQuestionLabel(questionResult.questionId, index + 1),
      "user-items-sorting": _ctx.getUserItemsSorting(questionResult),
      "display-overall-verdict-icon": true,
      "is-result-mode": true
    }, null, 8, ["question", "question-custom-label", "user-items-sorting"])) : _createCommentVNode("", true)], 64);
  }), 256))]);
}